import { render, staticRenderFns } from "./QuestionBuilderActionContent.vue?vue&type=template&id=daa86a8a&scoped=true"
import script from "./QuestionBuilderActionContent.vue?vue&type=script&lang=ts&scoped=true"
export * from "./QuestionBuilderActionContent.vue?vue&type=script&lang=ts&scoped=true"
import style0 from "./QuestionBuilderActionContent.vue?vue&type=style&index=0&id=daa86a8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daa86a8a",
  null
  
)

export default component.exports